import React, {useEffect, useRef, useState} from 'react'
import Layout from '../components/Layout'
import {ProgressSpinner} from 'primereact/progressspinner'
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import {Toast} from "primereact/toast";


const SelfCompetencyAssessment = () => {
    const primeToast = useRef(null)
    const {user} = useSelector(state => state['auth']);
    const [assessment, setAssessment] = useState([])
    const [competencyTitles, setCompetencyTitles] = useState([])
    const [optionList, setOptionList] = useState([]);
    const [selectedAssessment, setSelectedAssessment] = useState(0)
    const [userAssestmentOpinionID, setUserAssestmentOpinionID] = useState(0)
    const [quater, setQuater] = useState([])
    const [assessmentIndicator, setAssessmentIndicator] = useState({isLoading: false, list: []})
    const [assessmentSummary, setAssessmentSummary] = useState([])
    const [selfAssessmentSummery, setSelfAssessmentSummery] = useState([])

    useEffect(() => {
        getActiveAssessment()
        getActiveAssessmentSummary(user.registerID)
        getAssesstmentOpinionList()
        getQuarterActiveList()
        getAssessmentSummary();
        getSelfAssessmentSummary();
    }, [])


    const getAssessmentSummary = async () => {
        try {
            //api/competencyinformation/CompetencyUserStatusCount
            const response = await axios.post(BASE_URL + "/api/competencyinformation/CompetencyUserStatusCount", {
                RegisterID: user.registerID,
                UserRoleID: user.userRoleID
            });

            if (response.status === 200) {
                setAssessmentSummary(response.data)
                console.log("Forhad");
                console.log(response.data);
            }
        } catch (e) {
            console.log(e)
        }

    }

    const getSelfAssessmentSummary = async () => {
        try {
            const response = await axios.get(
                BASE_URL +
                "/api/assesmentinformation/GetAssesmentSummary/" +
                user.registerID
            );
            if (response.status === 200) {
                setSelfAssessmentSummery(response.data);
            }
        } catch (e) {}
    };

    const getActiveAssessmentSummary = (id) => {
        axios
          .get(
            BASE_URL +
              "/api/competencyinformation/CompetencySummaryData/"+ user.registerID)
          .then((response) => {
            console.log('hi');
              console.log(response.data);
            setCompetencyTitles(response.data);
          })
          .catch((e) => {
            console.log(e);
          });
      };
    const getActiveAssessment = () => {
        axios.get(BASE_URL + "/api/competencyinformation/GetRoleWiseCompetency/" + user.registerID)
            .then(response => {
                setAssessment(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const getAssesstmentOpinionList = () => {
        axios.get(BASE_URL + "/api/competencyOpinion/GetActiveList")
            .then(response => {
                setOptionList(response.data)
                console.log(response.data);
            })
            .catch(e => {
                console.log(e)
            })
    }
    //api/utility/GetAssestmentIndicator/17
    const getAssessmentIndicator = (id) => {
        setAssessmentIndicator({isLoading: true, list: []})
        const registerID = user.registerID
        console.log(registerID, id);
        axios.post(BASE_URL + "/api/competencyinformation/GetCompetencyWiseIndicator/",
            {
                "UserRoleID": user.userRoleID,
                "CompetencyID": id,
                "registerID":registerID
            }).then(response => {
            setAssessmentIndicator({isLoading: false, list: response.data})
        })
            .catch(e => {
                setAssessmentIndicator({isLoading: false, list: []})
                console.log(e)
            })            
    }

    //api/quarter/GetActiveList
    const getQuarterActiveList = () => {
        axios.get(BASE_URL + "/api/quarter/GetActiveList")
            .then(response => {
                setQuater(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }


    const onAssessmentValueChange = (e) => {
        setSelectedAssessment(e.currentTarget.value)
        getAssessmentIndicator(e.currentTarget.value)
    }

    const onUserAssessmentChange = e => {
        // console.log(e.currentTarget.value)
        setUserAssestmentOpinionID(e.target.value)
        console.log(userAssestmentOpinionID)
    }

    const onFormSubmit = e => {
        e.preventDefault()
        const competencyInformationID = 0
        const quarterID = quater[0].quarterID
        const competencyID = selectedAssessment
        const userCompetencyOpinionID = e.target.UserCompetencyOpinionId.value

        console.log(userAssestmentOpinionID)

        if (parseInt(userCompetencyOpinionID) === -1) {
            primeToast.current.show({
                severity: 'error',
                summary: 'error',
                detail: 'Please select Opinion',
                life: 3000
            });
        } else {
            const json = {
                "registerID": user.registerID,
                "quarterID": quarterID,
                "competencyID": competencyID,
                "userCompetencyOpinionID": userCompetencyOpinionID,
            }
            const headers = {
                'Content-Type': 'application/json',
            }

            console.log("else block====>", JSON.stringify(json))

            axios.post(BASE_URL + "/api/competencyinformation/SetUserAssesment", JSON.stringify(json), {headers: headers})
                .then(response => {
                    if (response.status === 200) {
                        primeToast.current.show({
                            severity: 'success',
                            summary: 'success',
                            detail: 'Assessment Saved Successfully',
                            life: 3000
                        });
                        getAssessmentSummary();
                        getActiveAssessmentSummary(user.registerID);
                    }
                }).catch(e => {
                console.log(e)
                primeToast.current.show({
                    severity: 'error',
                    summary: 'error',
                    detail: e.message,
                    life: 3000
                });
            })

        }


    }

    const assessmentBody = () => (
    <div className="row">
        <div className="col-sm-12 col-md-7 col-lg-7">        
        {assessmentIndicator.list.length !== 0 ? 
        <div className="card-body">
            <h5 className="card-title" style={{color:"#0b57d0", fontWeight:700}}>Definition: {assessmentIndicator.list.length === 0 ? "" : assessmentIndicator.list[0].competencyDefination}</h5>
            <form method="post" onSubmit={onFormSubmit}>
                <div className="question-item ps-4 pt-1">
                    {assessmentIndicator.list.map((question, index) =>
                        <div className="" key={index}>
                            <p><b>{question.indicatorSequenceNo}.</b> {question.indicatorTitle}</p>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-md-6 pt-3">
                        <label className='lblBlue'>Select Your Opinion</label>
                            <select className="form-select" name="UserCompetencyOpinionId"
                                    disabled={parseInt(assessmentSummary[0].rca) > 0}
                                    defaultValue={assessmentIndicator.list[0].userCompetencyOpinionID === null ? -1 : assessmentIndicator.list[0].userCompetencyOpinionID}
                                    onChange={onUserAssessmentChange}>
                                <option value={-1}>Select Your Opinion</option>
                                {optionList.map((value, index) => (
                                    <option
                                        key={index}
                                        value={value.competencyOpinionID}>
                                        {value.title}/{value.titleBangla}({value.weight})
                                    </option>))}
                            </select>
                        </div>
                    </div>


                </div>
                <div className="mt-1 ps-4 pt-1">                
                {
                  user.isLocked === true ? 
                  (
                    <h2 className="notUpdateComment" style={{fontSize:"1.5rem"}}>
                      *** This Quarter Already Locked..!
                    </h2>
                  ):(parseInt(assessmentSummary[0].rca) > 0 ?
                        <b className="notUpdateComment">*** Your supervisor's assessment has been completed. You can't modify anything.</b> :
                        <>     
                           
                            <button type="submit" className="btn btn-primary mt-2"><i class="bi bi-check-lg"/>
                            { assessmentIndicator.list[0].userCompetencyOpinionID === -1 ? " Save" : " Update" }
                            </button>
                            
                        </>)
                }
                </div>


            </form>

        </div> : <div>
                <h3 className="m-5">Core Competency Area</h3>
                <div className="m-5">
                    {selfAssessmentSummery.length !== 0 ?
                        (parseInt(selfAssessmentSummery[0].totalAssestmentSubmission)
                            !==
                            parseInt(selfAssessmentSummery[0].totalAssestment)) ? <b className="notUpdateComment"> "*** Please Complete Core Values First..!"</b> : "" : ""}
                </div>
                </div>
                }

        </div>
        <div className="col-sm-12 col-md-5 col-lg-5">
        <table className="table">
          <thead>
            <tr>
              <th scope="col" className='tdCenter'>#</th>
              <th scope="col">Name</th>
              <th scope="col" className='tdCenter'>RCL</th>
              <th scope="col">Opinion</th>
              <th scope="col" className='tdCenter'>Mark</th>
            </tr>
          </thead>
          <tbody>
            {competencyTitles.map((value, index) => (
              <tr key={index}>
                <td className='tdCenter'>{value.competencyInformationID > 0 ? <i className="bi bi-check-circle checkSuccess"/> : ""}</td>
                <td className='tdWhiteSpace'>{value.competencyName}</td>
                <td className='tdCenter'>{value.rca}</td>
                <td className='tdWhiteSpace'>{value.selfOpinion}</td>
                <td className='tdCenter'>{value.opinionValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
    </div>)

    return (
        <Layout>
            <Toast ref={primeToast}/>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-3">
                            <select className="form-select"
                                    disabled={selfAssessmentSummery.length !== 0 ?
                                        parseInt(selfAssessmentSummery[0].totalAssestmentSubmission)
                                        !==
                                        parseInt(selfAssessmentSummery[0].totalAssestment) : false}
                                    onChange={onAssessmentValueChange}
                                    aria-label=".form-select-sm example">
                                <option
                                    value={-1}>Select Competency</option>
                                {assessment.map(value => <option key={value.competencyID}
                                                                 value={value.competencyID}>
                                    {value.competencyName}</option>)}
                            </select>
                        </div>

                        <div className="col-md-5">
                          <b>Completed Core Competency:
                            {assessmentSummary.length !== 0 ? <> {assessmentSummary[0].totalComplete} out
                                of {assessmentSummary[0].totalCount}. </> : ""}</b>
                        </div>

                        <div className="col-md-4" style={{textAlign: 'right'}}>
                            <b>Quarter:</b> {quater.length !== 0 && quater[0].quarterName}/{new Date().getFullYear()}
                        </div>

                    </div>

                </div>
                {assessmentIndicator.isLoading ? <ProgressSpinner style={{height: 50, width: 50}}/> : assessmentBody()}

                {/*    card body end*/}

            </div>

        </Layout>

    )


}

export default SelfCompetencyAssessment